export class ColumnEditorModel {
  id = '';
  columnPos: number;
  name = '';
  isVisible?: boolean = true;
  initValue = '';
  isSort?: boolean = false;
  criteriaSort?: CriteriaSort = CriteriaSortEnum.DESC;
  orderSort?: number;
  formField: boolean;
  fieldType: FieldTypeSearch;
  searchCriteria?: SearchCriteriaEnum;
  nestedField = false;
  nestedPath = '';
  filterByRole?: string[];

  feature?: string;
}

export enum AreaEnum {
  POWER = 'POWER',
  GAS = 'GAS',
  WATER = 'WATER'
}

export const AllYesNoAnswerConst = [
  { name: 'Alle', value: null },
  { name: 'Ja', value: 'true' },
  { name: 'Nein', value: 'false' }
];

export const AccordingToCommissioningState: any[] = [
  { name: 'Alle', value: null },
  { name: 'geschlossene', value: 'completed' },
  { name: 'nicht geschlossene', value: 'notCompleted' }
];

export const EditingOrderTypeConst = [
  { name: 'Alle', value: '' },
  { name: 'Automatisch', value: 'true' },
  { name: 'Manuell', value: 'false' }
];

export enum SearchCriteriaEnum {
  LIKE = 'LIKE',
  LESS = 'LESS',
  EQUALS = 'EQUALS',
  NOTEQUAL = 'NOTEQUAL'
}

export type ResultType = 'OrderRequest' | 'FEATURE' | 'BusinessPartner';
export const ResultTypeEnum = {
  OrderRequest: 'OrderRequest' as ResultType,
  FEATURE: 'FEATURE' as ResultType
};

export type FieldJunction = 'AND' | 'OR';
export const FieldJunctionEnum = {
  AND: 'AND' as FieldJunction,
  OR: 'OR' as FieldJunction
};

export type CriteriaOperation =
  | 'EQUALS'
  | 'LIKE'
  | 'GREATER_OR_EQUALS'
  | 'LESS_OR_EQUALS'
  | 'LESS'
  | 'GREATER'
  | 'NOTEQUAL';
export const CriteriaOperationEnum = {
  EQUALS: 'EQUALS' as CriteriaOperation,
  LIKE: 'LIKE' as CriteriaOperation,
  GREATER_OR_EQUALS: 'GREATER_OR_EQUALS' as CriteriaOperation,
  LESS_OR_EQUALS: 'LESS_OR_EQUALS' as CriteriaOperation,
  LESS: 'LESS' as CriteriaOperation,
  GREATER: 'GREATER' as CriteriaOperation,
  NOTEQUAL: 'NOTEQUAL' as CriteriaOperation
};

export type FieldTypeSearch =
  | 'DATE'
  | 'LONG'
  | 'STRING'
  | 'BOOLEAN'
  | 'INPUT'
  | 'JOIN'
  | 'SELECT'
  | 'MULTISELECT'
  | 'MULTISELECTIN'
  | 'DATESTRING'
  | 'AUXDATE'
  | 'ACTIVITIESDATE'
  | 'withCompletedCR';
export const FieldTypeSearchEnum = {
  DATE: 'DATE' as FieldTypeSearch,
  DATESTRING: 'DATESTRING' as FieldTypeSearch,
  ACTIVITIESDATE: 'ACTIVITIESDATE' as FieldTypeSearch,
  DATERANGE: 'DATERANGE' as FieldTypeSearch,
  LONG: 'LONG' as FieldTypeSearch,
  STRING: 'STRING' as FieldTypeSearch,
  BOOLEAN: 'BOOLEAN' as FieldTypeSearch,
  INPUT: 'INPUT' as FieldTypeSearch,
  JOIN: 'JOIN' as FieldTypeSearch,
  SELECT: 'SELECT' as FieldTypeSearch,
  MULTISELECT: 'MULTISELECT' as FieldTypeSearch,
  MULTISELECTIN: 'MULTISELECTIN' as FieldTypeSearch,
  AUXDATE: 'AUXDATE' as FieldTypeSearch,
  relatedGRtoCR: 'relatedGRtoCR' as FieldTypeSearch,
  sealingFilter: 'sealingFilter' as FieldTypeSearch,
  withCompletedCR: 'withCompletedCR' as FieldTypeSearch,
  actionFilter: 'actionFilter' as FieldTypeSearch,
  CUSTOM: 'CUSTOM' as FieldTypeSearch
};

export class SearchDtoModel {
  resultType: ResultType = ResultTypeEnum.OrderRequest;
  filters: Array<SearchCriteriaDtoModel> = new Array<SearchCriteriaDtoModel>();
}

export class SearchCriteriaDtoModel {
  fieldName: string;
  operation: CriteriaOperation;
  fieldJunction: FieldJunction = FieldJunctionEnum.AND;
  filterValue: string;
  multiFilterValues: string[];
  fieldType: string = FieldTypeSearchEnum.STRING;
  nestedField: boolean;
  nestedPath = '';
}

export class SortDtoModel {
  fieldName: string;
  direction: string;
}

export type CriteriaSort = 'ASC' | 'DESC';
export const CriteriaSortEnum = {
  ASC: 'ASC' as CriteriaSort,
  DESC: 'DESC' as CriteriaSort
};

export class SearchSortDtoModel {
  searchDto: SearchDtoModel;
  sorts: Array<SortDtoModel>;
}
